import { FC } from "react";
import { useDispatch } from "react-redux";

import { UserPhoneNumberForm } from "Bands/components";
import { createUserPhoneNumber, dispatchGetUserPhoneNumbers } from "Bands/state";
import { USER_ACTIONS } from "Bands/types";
import { copy } from "shared/assets";
import { IFormButtons, IPhoneNumber } from "shared/types";
import { UserEntityModal } from "Bands/containers";
import { Phone } from "shared/assets/icons";

const { userPhoneNumber: phoneCopy } = copy;

interface Props {
  handleClose: () => void;
}

export const CreateUserPhoneNumberModal: FC<Props> = ({ handleClose }) => {
  const dispatch = useDispatch();

  const buttons: IFormButtons = {
    primary: {
      children: phoneCopy.buttons.create,
    },
    secondary: {
      onClick: handleClose,
    },
  };

  const handleSubmit = (data: IPhoneNumber) => {
    dispatch(createUserPhoneNumber(data));
  };

  const handleSuccess = () => {
    dispatchGetUserPhoneNumbers(dispatch);
  };

  return (
    <UserEntityModal
      title={phoneCopy.create.title}
      icon={Phone}
      action={USER_ACTIONS.createUserPhoneNumber}
      buttons={buttons}
      successMessage={phoneCopy.messages.created}
      Component={UserPhoneNumberForm}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
      handleSuccess={handleSuccess}
    />
  );
};
